export default class StatsManager {
  constructor(videoData) {
    this.videoData = videoData;
  }

  // eslint-disable-next-line class-methods-use-this
  sendEvents() {
    // logDebugging(`Stats Manager ${event}`, this.videoData);
    // this.videoData;
  }
}
